import React from 'react';
import MaskedInput from 'react-maskedinput';
import { Form } from 'react-bootstrap';
import { isMobile } from "react-device-detect";

import { validarData } from './../../../Funcoes';

const InputData = React.forwardRef(({
    data,
    onChange,
    placeholder='',
    size="md",
    isInvalid=false,
    readOnly=false,
    style,
    ...props
}, ref) => {

    const dataformatada = (value) => {
        const digitos = value.replace(/\D/g, ""); // só números
        let resultado = "";
        
        if(digitos.length > 0) resultado += digitos.substring(0, 2);
        if(digitos.length > 2) resultado += "/" + digitos.substring(2, 4);
        if(digitos.length > 4) resultado += "/" + digitos.substring(4, 8);
        
        return resultado;
    };
    
    return <>
        <MaskedInput 
            placeholder={placeholder}
            mask={"11/11/1111"}
            ref={ref}
            value={(data === null) ? '' : data.split('-').reverse().join('/')} 
            onChange={(e) => {
                const raw = e.target.value;

                const input = e.target;
                const pos = input.selectionStart;
                
                // se acabou de digitar dia ou mês, pula o cursor depois do "/"
                if(raw[pos - 1] === "/" && isMobile) {
                    setTimeout(() => {
                        input.setSelectionRange(pos, pos);
                    }, 0);
                }
                const formatado = dataformatada(e.target.value);
                onChange(formatado ? formatado.split("/").reverse().join("-") : null);
            }}
            className={["form-control", isInvalid ? 'is-invalid' : '' , validarData(data, 'invalid') ? 'is-invalid': '', size === "sm" && "form-control-sm"].join(' ')}
            readOnly={readOnly}
            style={style}
            {...props}
        />
        {validarData(data, 'invalid') &&
            <Form.Control.Feedback type="invalid">Data inválida</Form.Control.Feedback>
        }
    </>
})

// retorna
export default InputData; 